wizardSteps["room"] = {
    templateName: "#wizardStepRoom",
    skipTemplateCompilation: true,
    afterRender: function (ctx) {
        var contentContainer = document.querySelector("#vueContainer");
        if (!contentContainer) throw "Template container is missing from room step";

        // Vue instance
        var opts = {
            template: contentContainer.innerHTML,
            data: {
                isLoading: true,
                appliances: null,
                selected: currentEvent.appliance || null,
                showMulticardWarning: calendarConfiguration.loginUserType === 'Me' && !calendarConfiguration.hasAppliance
            },
            computed: {
                appointmentPrice: function () {
                    return ctx.model.o && ctx.model.o.price || 0;
                }
            },
            mounted: function () {
                if (!ctx.model.o) {
                    throw "Current event is missing from wizardStepRoom";
                }

                var locationId = ctx.model.o.locationId
                    ? ctx.model.o.locationId
                    : (calendarConfiguration.resources.length
                        ? calendarConfiguration.resources[0].clubId
                        : null
                    );

                if (!locationId) {
                    throw "Could not find any club ID";
                }

                ApiClient.loadAvailableAppliances(locationId, calendarConfiguration.calendarOwnerId, ctx.model.o.start, ctx.model.o.end2 || ctx.model.o.end, calendarConfiguration.calendarType !== "Appliances")
                    .done(function (c) {
                        console.info("done", c);
                        opts.data.appliances = c;
                    })
                    .fail(function () {
                        alert("Failed to load rooms");
                    })
                    .always(function () {
                        opts.data.isLoading = false;
                    });
            },
            methods: {
                select: function (appliance) {
                    if (opts.data.showMulticardWarning) {
                        return;
                    }
                    opts.data.selected = appliance;
                },
                formatPrice: function (price) {
                    if (typeof price !== "number") {
                        return price;
                    }

                    if (calendarConfiguration.currencySymbol === "$") {
                        return "$ " + price;
                    } else {
                        return price + "€";
                    }
                }
            }
        };
        new Vue(opts).$mount(contentContainer);

        // Bind button to remove room (getButtonList -> cancelRoom) if present
        // Timeout because button is not present at the time of execution
        setTimeout(function () {
            var cancelBtn = document.getElementById("m-modal__btn-room-cancel");
            if (cancelBtn) {
                cancelBtn.addEventListener("click", function () {
                    opts.data.selected = null;

                    // Propagate click to back button
                    document.getElementById("m-modal__btn-prev").click();
                });
            }
        }, 100);

        // Save data - can't put this into the context because it's not passed onto the save method.
        window.roomVueOpts = opts;
    },
    save: function () {
        if (roomVueOpts.data.selected) {
            // Deep copy to get around Vue's observer
            currentEvent.appliance = JSON.parse(JSON.stringify(roomVueOpts.data.selected));
        } else {
            currentEvent.appliance = null;
        }
        currentEvent.previousPrice = null; // Force update of price display
    },
    getButtonList: function (ctx) {
        var isAnOccObject = ctx.model.o.__isAnOccObject ? "appointment" : false;
        var showCalendarButton = calendarConfiguration.hasAppliance;

        return {
            // Booking an appointment with a room
            bookRoomBack: showCalendarButton ? isAnOccObject : false,
            // Booking a room without a related appointment
            bookRoomFinal: !ctx.model.o.__isAnOccObject,
            // Remove a room from a booked event, as long as it has not been submitted to the server yet
            cancelRoom: ctx.model.o.__isAnOccObject && !ctx.model.o.id && ctx.model.o.appliance,
            // Go to previous step (appointment)
            back: true
        };
    }
};
